/* eslint-disable */
import React, {useState} from 'react'
import "./topup.style.css"
import {numberWithCommas} from '../../_helpers'
import Layout from '../../component/Layout'
import _ from 'lodash'
import NavbarBackButton from "../../component/BackButton";

const TopUp = () => {
    let query = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))
    const [state, setState] = useState();
    const [nominal, setNominal] = useState([
        {
            label: "50.000",
            value: 50000,
            isSelected: false
        },
        {
            label: "100.000",
            value: 100000,
            isSelected: false
        },
        {
            label: "150.000",
            value: 150000,
            isSelected: false
        },
        {
            label: "200.000",
            value: 200000,
            isSelected: false
        }])

    const handleTopUp = (value) => {
        const data = _.findIndex(nominal, ['value', value])
        nominal.map(v => v.isSelected = false)
        nominal[data].isSelected = !nominal[data].isSelected
        setNominal(nominal)
        setState({
            ...state,
            amount: value
        })
    }

    const handlePayment = () => {

    }

    console.log(nominal)
    return (
        <Layout style={{height: '100%'}}>
            <nav className="single-navbar level is-mobile background-pink" role="navigation"
                 aria-label="main navigation">
                <div className="level-left">
                    <NavbarBackButton/>
                    <div className="level-item">
                        <strong className="column is-size-5 has-text-white">
                            Top Up Saldo
                        </strong>
                    </div>
                </div>
            </nav>
            <div className="container px-1">
                <p className="title-tenant has-text-weight-bold has-text-black">Hi, {query.get('memberName') !== undefined ? query.get('memberName').split("%20").join(" ") : null}</p>
                <div className="level is-mobile text-bold is-size-5">
                    <div className="level-left">
                        <div className="level-item">
                            <p className="pink" style={{fontSize: 20}}>Silahkan pilih nilai Top Up saldo</p>
                        </div>
                    </div>
                </div>
                <div className="columns is-multiline is-mobile px-4">
                    {nominal.map((value, key) => (
                        <div className="column is-half" key={key}>
                            <button className={`button has-text-centered is-fullwidth font-large ${value.isSelected ? "background-pink has-text-white" : ""}`}
                                    onClick={() => handleTopUp(value.value)}>
                                {value.label}
                            </button>
                        </div>
                    ))}
                    <hr/>
                    {state !== undefined ?
                        <div className="container" style={{marginTop: 20}}>
                            <p style={{fontSize: 20, fontWeight: 600}}>Payment Detail</p>
                            <div className="level is-mobile text-bold is-size-5 m-0">
                                <div className="level-left">
                                    <div className="level-item">
                                        <p className="pink">Amount</p>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <p className="has-text-black">Rp {numberWithCommas(state.amount)}</p>
                                </div>
                            </div>
                            <hr/>
                            <div className="level is-mobile text-bold is-size-5 m-0">
                                <div className="level-left">
                                    <div className="level-item">
                                        <p className="is-dark font-medium">Total</p>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <p className="has-text-black font-medium">Rp {numberWithCommas(state.amount)}</p>
                                </div>
                            </div>
                        </div> : null}
                </div>
            </div>
            <button
                className="button is-family-secondary has-text-centered is-fullwidth font-medium pay is-fixed-bottom-touch"
                style={{position: 'fixed', bottom: 200}}
                onClick={() => handlePayment()}>PAYMENT
            </button>
        </Layout>
    )
}

export default TopUp
